const LAYERS = {
  LOADING_LAYER: 1000,
  DIALOG_OVERLAY: 2000,
  DIALOG_MAIN: 2500
}

export default  LAYERS;